/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import Grid from '@mui/material/Grid';
import { Button, Dialog, DialogContent, DialogTitle, LinearProgress, TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import { blue } from '@mui/material/colors';
import Switch from '@mui/material/Switch';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { appendWafSafeFormField, navigationButtonStyle } from '../common/common';
import { editGeneralServiceInformationEndpoint, uploadGeneralServiceInformationEndpoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';
import logo from '../images/blueLogo.svg';
import icAdd from '../images/ic-add.svg';
import { actionCreators } from '../store/UploadGSInfo';
import DragDrop from './DragDrop';
import './styles.css';

// Theme migration pending; using default theme.

const BlueSwitch = withStyles({})(Switch as any);

interface Props {
    classes?: any;
    isEdit?: boolean;
    uploadDialogOpen: boolean;
    handleUploadGsInfoDialogClick: Function;
    clearAll: Function;
    selectedPdf: any;
    UpdateGsSelectedPdf: Function;
    handleGsInformationChange: Function;
    fileName: any;
    UpdateGsFileName: Function;
    gsPartNo: any;
    displayName: any;
    description: any;
    revision: any;
    releaseDate: any;
    handleGsreleaseDateChange: Function;
    checked: boolean;
    isFileChanged: any;
    handleGsActivateChange: Function;
    title?: string; // optional for parent flexibility
}
interface State {
    isFormSubmitted: boolean
    isUploading: boolean
    isSuccess: boolean
    isFailure: boolean
    bulletinURL: any,
    title: any,

}
const styles = () => ({
    input: {
        width: 300,
        backgroundColor: '#fff',
        padding: '10px 14px'
    },
    dateInput: {
        padding: '8px 14px',
        backgroundColor: '#fff'
    },
    selectInput: {
        width: 328,
        height: 40,
        backgroundColor: '#fff'
    },
    disabledOption: {
        color: 'gray'
    },
    navigationButton: navigationButtonStyle
});
class UploadGSInfoView extends React.Component<Props, State> {
    state = {
        isFormSubmitted: false,
        isUploading: false,
        isSuccess: false,
        isFailure: false,
        bulletinURL: "",
        title: 'General Service Information Upload'

    };
    handleClickOpen = () => {
        this.state.isSuccess = false;
        this.props.handleUploadGsInfoDialogClick(true);
    };
    handleClose = () => {
        this.setState({ isFormSubmitted: false });
        this.props.clearAll();
        this.props.handleUploadGsInfoDialogClick(false);
    };
    onDrop = async (selectedPdf: any, fileName: any) => {
        await this.props.UpdateGsFileName(`${fileName}`);
        this.props.UpdateGsSelectedPdf(selectedPdf);
    };
    handleChange = (event: any) => {
        console.log(event);
        this.props.handleGsInformationChange(event);
        console.log(this.props.releaseDate);
    };

    handlereleaseDateChange = (date: Date) => {
        this.props.handleGsreleaseDateChange(date);
    };

    handleDone = (event: any) => {
        window.location.reload();
    };
    handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(event);
        this.props.handleGsActivateChange(event);
    };

    handleUpload = async () => {
        console.log(this.props.gsPartNo);
        const uploadRequest = new FormData();
        appendWafSafeFormField(uploadRequest, 'filename', `${this.props.fileName}`, 'FileNameEncoding');
        if (!this.props.isEdit || this.props.isFileChanged) {
            uploadRequest.append('formfile', this.props.selectedPdf);
        }
        uploadRequest.append('displayname', `${this.props.displayName}`);
        uploadRequest.append('gspartnumber', this.props.gsPartNo === undefined || this.props.gsPartNo === null ? '' : `${this.props.gsPartNo}`);
        appendWafSafeFormField(
            uploadRequest,
            'description',
            this.props.description === undefined || this.props.description === null ? '' : this.props.description,
            'DescriptionEncoding');
        uploadRequest.append('revision', this.props.revision === undefined || this.props.revision === null ? '' : this.props.revision);
        appendWafSafeFormField(uploadRequest, 'releasedate', this.props.releaseDate.toJSON(), 'ReleaseDateEncoding');
        uploadRequest.append('active', JSON.stringify(this.props.checked));
        const isEditApi: boolean = this.props.isEdit || this.props.isFileChanged;
        if (isEditApi) {
            uploadRequest.append('isfilechanged', JSON.stringify(this.props.isFileChanged));
        }
        const userId: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Bearer ' + userId;
        const headerDict: any = {
            'Authorization': encodedToken,
        };
        this.setState({ isFormSubmitted: true, isUploading: true });
        fetch(isEditApi ? editGeneralServiceInformationEndpoint : uploadGeneralServiceInformationEndpoint, {
            headers: new Headers(headerDict),
            body: uploadRequest,
            method: 'POST'
        })
            .then(async (response: any) => {

                this.setState({ isUploading: false });
                const responseData = response.status;
                if (response.status === 201 || response.status === 200) {
                    this.setState({ isSuccess: true }, () => {
                        setTimeout(() => {
                            window.location.reload();
                            this.setState({
                                isSuccess: false
                            });
                        }, 5000);
                    });
                }
                else {
                    this.setState({ isFailure: true }, () => {
                        setTimeout(() => {
                            this.setState({
                                isFormSubmitted: false, isFailure: false
                            });
                        }, 5000);
                    });
                }
            });
    };
    render() {
        const { isFormSubmitted, isUploading, isSuccess, isFailure, title } = this.state;
        const { classes, isEdit, uploadDialogOpen, gsPartNo, displayName, description, revision, releaseDate, checked } = this.props;
        let isDisabled = true, isButtonDisable = true, ispartnumberfilled = true;

        if (this.props.selectedPdf === undefined) {

            isDisabled = true;
        }
        else {
            isDisabled = false;
            if (this.props.displayName === undefined || this.props.displayName === '') {
                isButtonDisable = true;
            }
            else {
                isButtonDisable = false;
            }
        }
        return (
            <div>
                {!isEdit && <Button id="upload-button" onClick={this.handleClickOpen}>
                    <Grid container justifyContent="space-evenly">
                        <img src={icAdd}
                            className="ic_add" />
                        <span className="uploadButtonText">{this.props.title}</span>
                    </Grid>
                </Button>
                }
                <Dialog
                    fullScreen
                    className="UploadDialog"
                    open={uploadDialogOpen}
                    onClose={this.handleClose}
                >
                    <DialogTitle className="dialogTitle">
                        <Grid container justifyContent="space-between">
                            <span>
                                <img src={logo} />
                                <span className="boldFont uploadTitle">{title}</span>
                            </span>

                            {(!isUploading) &&
                                <CloseIcon onClick={this.handleClose} style={{ cursor: 'pointer' }} />}
                        </Grid>
                    </DialogTitle>
                    <DialogContent className="uploadDialogContent">
                        {!isFormSubmitted &&
                            <Grid container className="uploadGrid">
                                <Grid className="dragdrop">
                                    <DragDrop onDrop={this.onDrop} selectedPdf={this.props.selectedPdf} />
                                </Grid>
                                <div className="classificationGrid">
                                <Grid className="classificationGridTitle">
                                    {this.props.selectedPdf === undefined ? '1. Upload the GS Document' : '2. Fill the Manual Information'}
                                    </Grid>
                                    <Grid container className="manualInformationContent">

                                        <Grid className="manualInformationLeft">Status</Grid>
                                            <Switch
                                                checked={checked}
                                                onChange={this.handleSwitchChange}
                                                name="checked"
                                                color="primary"
                                            />
                                    </Grid>
                                    <Grid container className="manualInformationContent">
                                        <Grid className="manualInformationLeft">GS P/N</Grid>
                                        <Grid><TextField
                                            name="gsPartNo"
                                            value={gsPartNo} disabled={isDisabled}
                                            onChange={this.handleChange}
                                            variant="outlined"
                                            InputProps={{ classes: { input: classes.input } }}
                                        /></Grid>
                                    </Grid>
                                    <Grid container className="manualInformationContent">
                                        <Grid className="manualInformationLeft">Display Name</Grid>
                                        <Grid><TextField
                                            name="displayName"
                                            value={displayName} disabled={isDisabled}
                                            onChange={this.handleChange}
                                            variant="outlined"
                                            InputProps={{ classes: { input: classes.input } }}
                                            required
                                        /></Grid>  </Grid>
                                    <Grid container className="manualInformationContent">
                                        <Grid className="manualInformationLeft">Description</Grid>
                                        <Grid><TextField
                                            name="description"
                                            value={description} disabled={isDisabled}
                                            onChange={this.handleChange}
                                            variant="outlined"
                                            InputProps={{ classes: { input: classes.input } }}
                                            required
                                        /></Grid>
                                    </Grid>
                                    <Grid container className="manualInformationContent">
                                        <Grid className="manualInformationLeft">Revision</Grid>
                                        <Grid><TextField
                                            name="revision"
                                            value={revision} disabled={isDisabled}
                                            onChange={this.handleChange}
                                            variant="outlined"
                                            InputProps={{ classes: { input: classes.input } }}
                                        /></Grid>        </Grid>
                                    <Grid container className="manualInformationContent">
                                        <Grid className="manualInformationLeft">Release Date</Grid>
                                        <Grid>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    format="MMM yyyy"
                                                    disabled={isDisabled}
                                                    value={releaseDate ? new Date(releaseDate + 'Z') : null}
                                                    views={["year","month"]}
                                                    onChange={(date: any) => this.handlereleaseDateChange(date)}
                                                    disableFuture
                                                    slotProps={{ textField: { variant: 'outlined', size: "small", sx: { width: 328, backgroundColor: "#fff" }, InputProps: { classes: { input: classes.dateInput } }, required: true } }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    </Grid>
                                    <Grid container justifyContent="flex-end" className="navigatiobuttonGrid manualInformationButton">
                                        <Button className={classes.navigationButton} disabled={isButtonDisable} onClick={this.handleUpload}>Done</Button>
                                    </Grid>
                                </div>

                            </Grid>

                        }

                        {isUploading &&
                            <Grid className="uploadDialogMessages">
                                <Grid container justifyContent="center">
                                    Uploading...
                                </Grid>
                                <Grid>
                                    <LinearProgress className="uploadprogress" />
                                </Grid>
                            </Grid>
                        }
                        {isSuccess &&
                            <Grid>
                                <Grid container justifyContent="center">
                                    <Grid>
                                        <CheckCircleOutlineIcon className="uploadSuccess" />
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center">
                                    Upload Successful. Redirecting...
                                </Grid>
                            </Grid>
                        }
                        {isFailure &&
                            <Grid className="uploadDialogMessages" container justifyContent="center">
                                There was an error while uploading. Please try again later...
                            </Grid>
                        }

                    </DialogContent>
                </Dialog>
            </div>

        );
    }
}
const mapStateToProps = (state: any) => ({
    uploadDialogOpen: state.uploadGSInfo.uploadDialogOpen,
    isEdit: state.uploadGSInfo.isEdit,
    selectedPdf: state.uploadGSInfo.selectedPdf,
    fileName: state.uploadGSInfo.fileName,
    gsPartNo: state.uploadGSInfo.gsPartNo,
    displayName: state.uploadGSInfo.displayName,
    description: state.uploadGSInfo.description,
    revision: state.uploadGSInfo.revision,
    releaseDate: state.uploadGSInfo.releaseDate,
    isFileChanged: state.uploadGSInfo.isFileChanged,
    checked: state.uploadGSInfo.checked
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

interface ExtraProps {
    title?: string;
}

// -------------------- Export Connected Component --------------------
export default connect<
    ReturnType<typeof mapStateToProps>,   // Redux state props
    typeof mapDispatchtoProps,           // Redux dispatch props
    ExtraProps                           // Extra props from parent
>(
    mapStateToProps,
    mapDispatchtoProps
)(withStyles(styles)(UploadGSInfoView));
